import { getValue } from "./getRowValue";
import { Workbook, DataCache, Data } from "../core/Workbook";

// Export for testing only

export function refreshDataCache(
  dataCache: DataCache,
  workbook: Workbook
): DataCache {
  // Naive implementation: just regenerate cache from scratch
  // TODO: only regenerate parts that have changed
  let newDataCache: DataCache = {};
  Object.entries(workbook.data.datasets).forEach(([key, dataset]) => {
    let cachedData: Data = {};
    Object.keys(dataset.data).forEach((objectKey) => {
      let cachedRow: { [key: string]: any } = {};
      Object.keys(dataset.properties.descriptors).forEach((propertyKey) => {
        let value = getValue(
          objectKey,
          propertyKey,
          dataset.data,
          dataset.properties,
          workbook
        );
        cachedRow[propertyKey] = value;
      });
      cachedData[objectKey] = cachedRow;
    });
    newDataCache[key] = cachedData;
  });
  return newDataCache;
}
